import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { NearestUserListComponent } from './nearest-user-list/nearest-user-list.component'

import { UserService } from './shared/user.service'
import { UserLocationService } from './shared/user-location/user-location.service'
import { User } from './shared/user.model'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NearestUserListComponent],
  providers: [ UserService, UserLocationService ]
})
export class UsersModule { }

export { UserService, UserLocationService, User }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/users/users.module.ts